import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IZone } from '@obvious.tech/constellation'

export const Zone = defineEntity('Zone', {
  endpoint: 'geolocation/api/Zone',
  schema: SNoop<IZone>(),
})